<template>
    <div class="admin-panel">
      <h2>Super Admin - Manage Shops</h2>
  
      <h3>Add a New Shop</h3>
      <form @submit.prevent="addShop">
        <label>Shop Name:</label>
        <input v-model="shopName" type="text" placeholder="Enter Shop Name" required />
  
        <label>Owner Email:</label>
        <input v-model="ownerEmail" type="email" placeholder="Enter Owner Email" required />
  
        <button type="submit" :disabled="loading">
          {{ loading ? "Adding..." : "Add Shop" }}
        </button>
      </form>
  
      <h3>Existing Shops</h3>
      <p v-if="loadingShops">⏳ Loading shops...</p>
      <ul v-if="shops.length">
        <li v-for="shop in shops" :key="shop.id">
          <strong>{{ shop.name }}</strong> (Owner: {{ shop.ownerEmail }})
        </li>
      </ul>
      <p v-else>No shops found.</p>
  
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        shopName: "",
        ownerEmail: "",
        shops: [],
        superAdminEmail: "teeyaibeef@gmail.com", // Replace with logged-in user's email
        loading: false,
        loadingShops: false,
        errorMessage: "",
      };
    },
    methods: {
      async fetchShops() {
        try {
          this.loadingShops = true;
          const response = await axios.get("https://getshops-u32waniu4a-df.a.run.app");
          this.shops = response.data;
        } catch (error) {
          console.error("❌ Error fetching shops:", error);
          this.errorMessage = "❌ Failed to load shops.";
        } finally {
          this.loadingShops = false;
        }
      },
      async addShop() {
        if (!this.shopName || !this.ownerEmail) {
          alert("❌ Please enter a shop name and owner email.");
          return;
        }
  
        try {
          this.loading = true;
          const response = await axios.post("https://addshop-u32waniu4a-df.a.run.app", {
            name: this.shopName,
            ownerEmail: this.ownerEmail,
            superAdminEmail: this.superAdminEmail,
          });
  
          if (response.data.success) {
            alert("✅ Shop added successfully!");
            this.shopName = "";
            this.ownerEmail = "";
            this.fetchShops(); // Refresh shop list
          } else {
            this.errorMessage = response.data.error;
          }
        } catch (error) {
          console.error("❌ Error adding shop:", error);
          this.errorMessage = "❌ Failed to add shop.";
        } finally {
          this.loading = false;
        }
      },
    },
    mounted() {
      this.fetchShops();
    },
  };
  </script>
  
  <style scoped>
  .admin-panel {
    max-width: 500px;
    margin: auto;
    text-align: center;
  }
  
  form {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }
  
  input, button {
    margin-bottom: 10px;
    padding: 10px;
  }
  
  button {
    background-color: #28a745;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  button:hover:not(:disabled) {
    background-color: #218838;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }
  
  .error {
    color: red;
    font-weight: bold;
  }
  </style>
  